module.exports = __webpack_public_path__ + "media/images/number_15-9fed469564644005b913a17bcd5b33b2.png";